module.exports = __webpack_public_path__ + "img/iconPhoneNavy.dea812f4.svg";